<template>
  <div style="margin: 100px auto 100px; margin-top: 50px; margin-left: 100px; max-width: 80%; text-align: left;">

    <el-row style="margin-top: 70px; margin-bottom: 30px;">
      <el-col :span="12" class="grid-content info-bg">
        <div>
          <el-button class="el-icon-d-arrow-right dropdown-style001" type="text" @click="dialogEmpIns = true">
            &emsp;&emsp;
            雇用保険書類一覧
          </el-button>
        </div>
      </el-col>

    </el-row>

    <el-row>
      <el-col :span="12" class="grid-content info-bg">
        <div>
          <el-button class="el-icon-d-arrow-right dropdown-style001" type="text" @click="dialogHealth = true" style="margin-left: 50px; margin-right: 30px;"> &emsp;&emsp; 健康保険書類一覧
          </el-button>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12" class="grid-content info-bg">
        <div>
          <el-button class="el-icon-d-arrow-right dropdown-style001" type="text" @click="dialogLaborIns = true" style="margin-left: 50px; margin-right: 30px;"> &emsp;&emsp; 労働保険
          </el-button>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12" class="grid-content info-bg">
        <div>
          <el-button class="el-icon-d-arrow-right dropdown-style001" type="text" @click="dialogSocialIns = true" style="margin-left: 50px; margin-right: 30px;"> &emsp;&emsp; 社会保険
          </el-button>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12" class="grid-content info-bg">
        <div>
          <el-button class="el-icon-d-arrow-right dropdown-style001" type="text" @click="dialogOther = true" style="margin-left: 50px; margin-right: 30px;"> &emsp;&emsp; その他
          </el-button>
        </div>
      </el-col>
    </el-row>

    <!-- Emp dialog -->
    <el-dialog title="雇用保険書類一覧" :append-to-body="true" :visible.sync="dialogEmpIns" width="66%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="195px" class="demo-ruleForm" size="mini" style="margin-left: 50px">
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="foreigner1()" target="_blank"> &emsp; 雇用保険の被保険者である外国人に係る届出［PDF形式：277KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="foreigner2()" target="_blank"> &emsp; 雇用保険の被保険者ではない外国人に係る届出［PDF形式：98KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="businessOwner()" target="_blank"> &emsp; 雇用保険事業主事業所各種変更届［PDF形式：176KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="businessEstablish()" target="_blank"> &emsp; 雇用保険適用事業所設置届［PDF形式：219KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="businessAbolition()" target="_blank"> &emsp; 雇用保険適用事業所廃止届［PDF形式：160KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="insuranceExemption()" target="_blank"> &emsp; 雇用保険適用除外申請書［PDF形式：630KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="insuranceQualification()" target="_blank"> &emsp; 雇用保険被保険者資格取得届［PDF形式：203KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="insuranceQualificationTargetPerson()" target="_blank"> &emsp;
              雇用保険被保険者資格取得届光ディスク等提出用総括票に係る対象者名簿［PDF形式：114KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="insurerNameChange()" target="_blank"> &emsp;
              雇用保険被保険者資格喪失届・氏名変更届［PDF形式：170KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="insuranceDisqualification()" target="_blank"> &emsp;
              雇用保険被保険者資格喪失届光ディスク等提出用総括票［PDF形式：203KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="insurerTransfer()" target="_blank"> &emsp;
              雇用保険被保険者転勤届［PDF形式：133KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="insurerTurnover()" target="_blank"> &emsp;
              雇用保険被保険者転勤届雇用保険被保険者離職票再交付申請書［PDF形式：163KB］</el-link>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" type="primary" size="medium">{{
          $t("general.close")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- Health dialog -->
    <el-dialog title="健康保険書類一覧" :append-to-body="true" :visible.sync="dialogHealth" width="66%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="195px" class="demo-ruleForm" size="mini" style="margin-left: 50px">
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="childcareLeave()" target="_blank"> &emsp; 健康保険・厚生年金保険育児休業等取得者申出書終了届 ［PDF形式：632KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="childcareLeaveEnd()" target="_blank"> &emsp; 健康保険・厚生年金保険被保険者育児休業等終了時報酬月額変更届［PDF形式：584KB］
            </el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="healthInsDependent()" target="_blank"> &emsp; 健康保険・被扶養者（異動）届（国民年金第3号被保険者関係届）［PDF形式：385KB］
            </el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="healthInsQualification()" target="_blank"> &emsp; 健康保険・被保険者資格証明書交付申請書［PDF形式：2,049KB］
            </el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="healthInsLossConfirmation()" target="_blank"> &emsp; 健康保険・厚生年金保険　資格取得・喪失等確認請求書［PDF形式：166KB］
            </el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="healthInsNameChange()" target="_blank"> &emsp; 健康保険・厚生年金保険　被保険者氏名変更（訂正）届［PDF形式：177KB］
            </el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="healthInsOver70()" target="_blank"> &emsp;
              健康保険・厚生年金保険　被保険者資格取得届／厚生年金保険70歳以上被用者該当届［PDF形式：437KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="healthInsOver70Loss()" target="_blank"> &emsp;
              健康保険・厚生年金保険　被保険者資格喪失届／厚生年金保険70歳以上被用者不該当届［PDF形式：575KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="healthInsAddressChange()" target="_blank"> &emsp;
              健康保険・健康保険・厚生年金保険 被保険者住所変更届（国民年金第3号被保険者住所変更届）［PDF形式：524KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="healthInsAnnuity()" target="_blank"> &emsp;
              健康保険・厚生年金保険事業所を設立［PDF形式：272KB］</el-link>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" type="primary" size="medium">{{
           $t("general.close")
         }}</el-button>
      </span>
    </el-dialog>

    <!-- Labor dialog -->
    <el-dialog title="労働保険" :append-to-body="true" :visible.sync="dialogLaborIns" width="66%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="195px" class="demo-ruleForm" size="mini" style="margin-left: 50px">
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="directDebitPayment()" target="_blank"> &emsp; 口座振替納付書［PDF形式：275KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="insurerRelationship()" target="_blank"> &emsp; 労働保険保険関係成立［PDF形式：2,976KB］
            </el-link>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" type="primary" size="medium">{{
             $t("general.close")
           }}</el-button>
      </span>
    </el-dialog>

    <!-- Social dialog -->
    <el-dialog title="社会保険" :append-to-body="true" :visible.sync="dialogSocialIns" width="66%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="195px" class="demo-ruleForm" size="mini" style="margin-left: 50px">
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="attoneryPower()" target="_blank"> &emsp; 委任状［PDF形式：207KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="pensionNotebook()" target="_blank"> &emsp; 年金手帳再交付申請書［PDF形式：264KB］
            </el-link>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" type="primary" size="medium">{{
               $t("general.close")
             }}</el-button>
      </span>
    </el-dialog>

    <!-- Other dialog -->
    <el-dialog title="その他" :append-to-body="true" :visible.sync="dialogOther" width="66%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="195px" class="demo-ruleForm" size="mini" style="margin-left: 50px">
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="reemploymentAllowance()" target="_blank"> &emsp; 再就職手当支給申請書［PDF形式：170KB］</el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="calculationBasis()" target="_blank"> &emsp; 算定基礎届［PDF形式：1,114KB］
            </el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="businessSuspension()" target="_blank"> &emsp; 適用事業所が廃止、休止等により適用事業所［PDF形式：428KB］
            </el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="workerList()" target="_blank"> &emsp; 労働者名簿［PDF形式：19KB］
            </el-link>
          </div>
        </el-row>
        <el-row>
          <div class="el-icon-paperclip">
            <el-link @click="myNumber()" target="_blank"> &emsp; 個人番号登録・変更届［PDF形式：141KB］
            </el-link>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" type="primary" size="medium">{{
                 $t("general.close")
               }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogEmpIns: false,
      dialogHealth: false,
      dialogLaborIns: false,
      dialogSocialIns: false,
      dialogOther: false,
    };
  },
  methods: {
    //EmpIns
    foreigner1() {
      window.open("/pdfSample/雇用保険の被保険者である外国人に係る届出sample.pdf");
    },
    foreigner2() {
      window.open("/pdfSample/雇用保険の被保険者ではない外国人に係る届出sample.pdf");
    },
    businessOwner() {
      window.open("/pdfSample/雇用保険事業主事業所各種変更届sample.pdf");
    },
    businessEstablish() {
      window.open("/pdfSample/雇用保険適用事業所設置届sample.pdf");
    },
    businessAbolition() {
      window.open("/pdfSample/雇用保険適用事業所廃止届sample.pdf");
    },
    insuranceExemption() {
      window.open("/pdfSample/雇用保険適用除外申請書sample.pdf");
    },
    insuranceQualification() {
      window.open("/pdfSample/雇用保険被保険者資格取得届sample.pdf");
    },
    insuranceQualificationTargetPerson() {
      window.open("/pdfSample/雇用保険被保険者資格取得届光ディスク等提出用総括票に係る対象者名簿sample.pdf");
    },
    insurerNameChange() {
      window.open("/pdfSample/雇用保険被保険者資格喪失届・氏名変更届sample.pdf");
    },
    insuranceDisqualification() {
      window.open("/pdfSample/雇用保険被保険者資格喪失届光ディスク等提出用総括票sample.pdf");
    },
    insurerTransfer() {
      window.open("/pdfSample/雇用保険被保険者転勤届sample.pdf");
    },
    insurerTurnover() {
      window.open("/pdfSample/雇用保険被保険者離職票再交付申請書sample.pdf");
    },

    //HealthIns
    childcareLeave() {
      window.open("/pdfSample/健康保険厚生年金保険育児休業等取得者申出書終了届sample.pdf");
    },
    childcareLeaveEnd() {
      window.open("/pdfSample/健康保険厚生年金保険被保険者育児休業等終了時報酬月額変更届sample.pdf");
    },
    healthInsDependent() {
      window.open("/pdfSample/健康保険　被扶養者（異動）届（国民年金第3号被保険者関係届）sample.pdf");
    },
    healthInsQualification() {
      window.open("/pdfSample/健康保険　被保険者資格証明書交付申請書sample.pdf");
    },
    healthInsLossConfirmation() {
      window.open("/pdfSample/健康保険・厚生年金保険　資格取得・喪失等確認請求書sample.pdf");
    },
    healthInsNameChange() {
      window.open("/pdfSample/健康保険・厚生年金保険　被保険者氏名変更（訂正）届sample.pdf");
    },
    healthInsOver70() {
      window.open("/pdfSample/健康保険・厚生年金保険　被保険者資格取得届／厚生年金保険70歳以上被用者該当届sample.pdf");
    },
    healthInsOver70Loss() {
      window.open("/pdfSample/健康保険・厚生年金保険　被保険者資格喪失届／厚生年金保険70歳以上被用者不該当届sample.pdf");
    },
    healthInsAddressChange() {
      window.open("/pdfSample/健康保険・厚生年金保険 被保険者住所変更届（国民年金第3号被保険者住所変更届sample.pdf");
    },
    healthInsAnnuity() {
      window.open("/pdfSample/健康保険・厚生年金保険事業所を設立sample.pdf");
    },

    //laborIns
    directDebitPayment() {
      window.open("/pdfSample/口座振替納付書sample.pdf");
    },
    insurerRelationship() {
      window.open("/pdfSample/労働保険保険関係成立sample.pdf");
    },

    //social
    attoneryPower() {
      window.open("/pdfSample/委任状sample.pdf");
    },
    pensionNotebook() {
      window.open("/pdfSample/年金手帳再交付申請書sample.pdf");
    },

    //other
    reemploymentAllowance() {
      window.open("/pdfSample/再就職手当支給申請書sample.pdf");
    },
    calculationBasis() {
      window.open("/pdfSample/算定基礎届sample.pdf");
    },
    businessSuspension() {
      window.open("/pdfSample/適用事業所が廃止、休止等により適用事業所sample.pdf");
    },
    workerList() {
      window.open("/pdfSample/労働者名簿sample.pdf");
    },
    myNumber() {
      window.open("/pdfSample/個人番号登録・変更届sample.pdf");
    },

    jump(path) {
      this.$router.replace(path);
    },
    cancel() {
      this.dialogEmpIns = false;
      this.dialogHealth = false;
      this.dialogLaborIns = false;
      this.dialogSocialIns = false;
      this.dialogOther = false;
    },
  },
};
</script>

<style scoped>
.dropdown-style001 {
  margin-left: 50px;
  margin-right: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 100px;
  font-size: 20px;
}

.info-bg {
  background: #eeeeee;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/FileList.vue